/**
 * The attendance reports answer with their headline figures as a list, `[{key, label, value}]`,
 * while the screens want to pick them out by name and pair each with its own wording and tone.
 * Tolerates a plain object too, so a report that answers either way still reads.
 */
export const kpiMap = (data) => {
  const kpis = data?.kpis;
  if (!kpis) return {};
  if (!Array.isArray(kpis)) return kpis;
  return Object.fromEntries(kpis.map((k) => [k.key, k.value]));
};

export default kpiMap;
